import { render, staticRenderFns } from "./ReturnedChecksTable.vue?vue&type=template&id=c12e70cc&scoped=true"
import script from "./ReturnedChecksTable.vue?vue&type=script&lang=js"
export * from "./ReturnedChecksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12e70cc",
  null
  
)

export default component.exports